














import { computed, defineComponent, ref } from "@vue/composition-api";
import { Story } from "@scrile/api-provider/dist/projects/scrileConnect/StoriesProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { ViewStoriesSettings } from "@/types";
import { EVENTS } from "@/const";
import BaseImage from "@/components/BaseImage";
import BaseSpinner from "@/components/BaseSpinner";
import ContentFeedCover from "@/components/ContentFeedCover";

export default defineComponent({
  name: "MessageItemStoryView",
  components: { BaseImage, ContentFeedCover, BaseSpinner },
  props: {
    id: { type: String, required: true },
    opponent: { type: Boolean, required: true },
  },
  setup(props) {
    const story = ref<Story | null>(null);
    const loading = ref(false);
    const isDeleted = computed(() => !story.value?.contentFeed);

    const onClick = () => {
      if (!story.value || !story.value.contentFeed) return;
      emitter.emit<ViewStoriesSettings>(EVENTS.STORIES_SHOW, {
        storyPublishers: [{ userId: story.value.contentFeed.user.id, user: story.value.contentFeed.user }],
        storyIds: [story.value.id],
      });
    };

    const getStory = async () => {
      try {
        loading.value = true;
        providers.StoriesProvider.setReceiveErrors(false);
        const response = await providers.StoriesProvider.searchStories({
          data: { ids: [props.id], archived: false },
        });
        if (response.result.length) story.value = response.result[0];
      } catch (e) {
        story.value = null;
      } finally {
        loading.value = false;
      }
    };
    getStory();

    return { loading, story, isDeleted, onClick };
  },
});
